import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from 'components/App';
import AppIntlProvider from 'components/App/AppIntlProvider/AppIntlProvider';
import setupAndCreateStore from 'redux/setupAndCreateStore';
import { initiateSentry } from './utils/errorReporter';
import './index.scss';

const store = setupAndCreateStore();
initiateSentry();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <Provider store={store}>
      <AppIntlProvider>
        <App />
      </AppIntlProvider>
    </Provider>
  </StrictMode>,
);
